// extracted by mini-css-extract-plugin
export default {"AnnotationTag":"AnnotationTag_AnnotationTag__hMjQW","AnnotationTag-Icon":"AnnotationTag_AnnotationTag-Icon__dXHMC"};